export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboards.text',
        icon: 'bx-home-circle',
        subItems: [
           
            {
                id: 2,
                label: 'menuitems.dashboards.list.principal',
                link: '/',
                parentId: 1
            },
        ]
    },
    {
        id: 12,
        label: "menuitems.inventario.text",
        icon: "bx-store",
        subItems: [
           /*  {
                id: 13,
                label: "menuitems.inventario.list.tiendas",
                link: "/inventario/tiendas",
                parentId: 12
            }, */
            {
                id: 14,
                label: "menuitems.inventario.list.ubicaciones",
                link: "/inventario/departamentos",
                parentId: 12
            },/* 
            {
                id: 15,
                label: "menuitems.inventario.list.categoria",
                link: "/inventario/categoria",
                parentId: 12
            }, */
            {
                id: 16,
                label: "menuitems.inventario.list.marcas",
                link: "/inventario/marcas",
                parentId: 12
            },
            {
                id: 17,
                label: "menuitems.inventario.list.presentaciones",
                link: "/inventario/presentaciones",
                parentId: 12
            },
            {
                id: 38,
                label: "menuitems.inventario.list.autos",
                link: "/inventario/autos",
                parentId: 12
            },
            {
                id: 18,
                label: "menuitems.inventario.list.productos",
                link: "/inventario/productos",
                parentId: 14
            },
           /*  {
                id: 19,
                label: "menuitems.inventario.list.servicios",
                link: "/inventario/servicios",
                parentId: 15
            }, */
           /*  {
                id: 20,
                label: "menuitems.inventario.list.gastosinternos",
                link: "/inventario/gastosinternos",
                parentId: 16
            }, */
           
        ]
    },
    {
        id: 34,
        label: "menuitems.compras.principal",
        icon: "bx bx-shopping-bag",
        subItems: [
            {
                id: 35,
                label: "menuitems.compras.list.proveedor",
                link: "/compras/proveedor",
                parentId: 28
            },
            
            {
                id: 36,
                label: "menuitems.compras.list.ordendecompra",
                link: "/compras/ordendecompra",
                parentId: 29
            },
            
            {
                id: 37,
                label: "menuitems.compras.list.compras",
                link: "/compras/compras",
                parentId: 29
            },
            {
                id: 35,
                label: "menuitems.compras.list.credito",
                link: "/compras/credito",
                parentId: 28
            },
        ]
    },
    {
        id: 21,
        label: "menuitems.administracion.text",
        icon: "bx-cog",
        subItems: [
            {
                id: 22,
                label: "menuitems.administracion.list.empleados",
                link: "/administracion/empleados",
                parentId: 18
            },
            // {
            //     id: 23,
            //     label: "menuitems.administracion.list.proveedores",
            //     link: "/administracion/proveedores",
            //     parentId: 19
            // },
            // {
            //     id: 24,
            //     label: "menuitems.administracion.list.usuarios_especiales",
            //     link: "/administracion/usuarios_especiales",
            //     parentId: 20
            // },
            {
                id: 25,
                label: "menuitems.administracion.list.usuarios",
                link: "/administracion/usuarios",
                parentId: 21
            },
            {
                id: 25,
                label: "menuitems.administracion.list.reportes",
                link: "/administracion/reportes",
                parentId: 1001
            },
           
        ]
    },
    {
        id: 2612,
        label: "menuitems.reportes.text",
        icon: "bx-file",
        subItems: [
          {
            id: 27,
            label: "menuitems.reportes.list.departamento",
            link: "/reportes/departamento",
            parentId: 2612,
          },
          {
            id: 28,
            label: "menuitems.reportes.list.ventas",
            link: "/reportes/ventas",
            parentId: 2612,
          },
          {
            id: 27,
            label: "menuitems.reportes.list.clientesf",
            link: "/reportes/clientesf",
            parentId: 2612,
          },
          {
            id: 28,
            label: "menuitems.reportes.list.existenciap",
            link: "/reportes/existenciap",
            parentId: 2612,
          },
          {
            id: 27,
            label: "menuitems.reportes.list.clientes",
            link: "/reportes/clientes",
            parentId: 2612,
          },
          {
            id: 28,
            label: "menuitems.reportes.list.compras",
            link: "/reportes/compras",
            parentId: 2612,
          },
          {
            id: 27,
            label: "menuitems.reportes.list.cardex",
            link: "/reportes/cardex",
            parentId: 2612,
          },
          {
            id: 28,
            label: "menuitems.reportes.list.cortecaja",
            link: "/reportes/cortecaja",
            parentId: 2612,
          },
        ],
      },
    
    
];

